export default __webpack_public_path__ + "static/media/joaquim-bento.9f8dd841.jpg";